import { Array } from '@common/Array/Array'
import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

import type { TOs } from '../definitions'
import {
  IOS_OSS, LINUX_OSS, MAC_OS_OSS,
  WINDOWS_OSS, ANDROID_OSS, ACCEPTED_OSS
} from '../definitions'

/**
 * Os elkérése, userAgent alapján.
 * @param ua - UserAgent.
 */
export default function getOs (ua: string): TOs {
  const os = userAgentParser.getOs(ua)

  if (Array.includes(ACCEPTED_OSS, os)) {
    if (Array.includes(ANDROID_OSS, os)) {
      return 'Android'
    }

    if (Array.includes(WINDOWS_OSS, os)) {
      return 'Windows'
    }

    if (Array.includes(LINUX_OSS, os)) {
      return 'Linux'
    }

    if (Array.includes(IOS_OSS, os)) {
      return 'iOS'
    }

    if (Array.includes(MAC_OS_OSS, os)) {
      return 'Mac OS'
    }
  }

  return undefined
}
